export default {
  clear_snackbar_timer() {
    if (this.snackbar_timeout_id) {
      clearTimeout(this.snackbar_timeout_id);
      this.snackbar_timeout_id = null;
    }
  },

  start_snackbar_timer() {
    this.clear_snackbar_timer();
    this.snackbar_timeout_id = setTimeout(() => {
      this.error_message = '';
      this.success_message = '';
      this.snackbar_timeout_id = null;
    }, 5000);
  },

  clear_error_message() {
    this.clear_snackbar_timer();
    this.error_message = '';
  },

  clear_success_message() {
    this.clear_snackbar_timer();
    this.success_message = '';
  },

  set_error_message(message) {
    this.error_message = message || 'Something went wrong. Please try again.';
    this.success_message = '';
    this.start_snackbar_timer();
  },

  set_success_message(message) {
    this.success_message = message || '';
    this.error_message = '';

    if (message) {
      this.start_snackbar_timer();
    }
  }
};
